<template>
  <div>
    <div class="audio_box_s">
      <div>
        <div class="audiotitlex">
          <div class="img_box">
            <img class="img_box" src="@/assets/icon/yinyue.png" />
          </div>
          <div class="fileName_box">
            {{ fileName }}
          </div>
        </div>
      </div>
      <div class="_box">
        <div class="image_box_row">
          <el-image
            class="read_leftt1_imgx"
            :src="cover"
            fit="contain"
          ></el-image>
        </div>
      </div>
      <div class="top">
        <audioPlay ref="audio" :url="filePath" :title="fileName"></audioPlay>
      </div>
    </div>
  </div>
</template>
<script>
import { videoPlayer } from "vue-video-player";
import "video.js/dist/video-js.css";
import audioPlay from "@/views/onlineReading/mobileClient/components/audioPlay1.vue";
export default {
  components: {
    videoPlayer,
    audioPlay,
  },
  name: "xmlAudioRead",
  data() {
    return {};
  },
  props: {
    cover: {
      type: String,
      default: "",
    },
    filePath: {
      type: String,
      default: "",
    },
    fileName: {
      type: String,
      default: "",
    },
  },
  created() {},
  methods: {
    tabbook(item, index, filePath) {
      this.$refs.audio.onPlayerEnded();
      // this.loading = this.$loading({
      //   lock: true,
      // });
      // this.goodsFileId = item.filesId;
      // this.fileName = item.sourceName;
      // this.filesId = item.filesId;
      // this.goodsFilePath = filePath;
      // this.loading.close();
    },
  },
};
</script>

<style scoped>
.audio_box_s {
  float: left;
  width: calc(100% - 340px);
  min-height: 95vh;
  position: relative;
  background: #fff;
}

.audio_box {
  width: 1400px;
  margin: 0 auto;
}

.audio_con {
  width: calc(100% - 700px);
  margin: 30px auto;
  background: #fff;
}

.audio_con .video-player {
  height: 30px;
  position: relative;
  padding: 0;
}

.audio_con ::v-deep .video-js {
  height: 30px;
  padding: 0;
}

.audio_con .vjs-tech {
  height: 30px;
  padding: 0;
}

.audio_con ::v-deep .video-js .vjs-tech {
  display: none;
}

.audio_con .vjs-control-bar {
  height: 30px;
  padding: 0;
  position: absolute;
  left: 0;
  bottom: 0;
}

.audio_con ::v-deep .vjs-control-bar {
  opacity: 1 !important;
  display: flex !important;
}

.audio_con ::v-deep .vjs-big-play-button {
  display: none;
}

/* .audio_con::v-deep.vjs-play-control {
		display: none;
	} */

.read_leftt1_img {
  float: left;
  width: 80px;
  height: 80px;
  border-radius: 6px;
  border: 1px solid #f2f2f2;
  background: #fff;
}
.audiotitle {
  margin-top: 10px;
  text-align: center;
}

.audio_box_l {
  position: relative;
}

.audio_box_l_ico {
  position: absolute;
  left: 27px;
  top: 27px;
  z-index: 10;
  color: #ddd;
  font-size: 30px;
  cursor: pointer;
}

.audio_box_l_ico2 {
  position: absolute;
  left: 27px;
  top: 27px;
  z-index: 10;
  color: #ddd;
  font-size: 30px;
  cursor: pointer;
}

.close_ico {
  position: absolute;
  right: 10px;
  top: 10px;
  color: #fff;
  cursor: pointer;
}
.img_box {
  width: 20px;
  height: 20px;
  background: #666666;
}
.audiotitlex {
  display: flex;
  flex-direction: row;
  align-items: center;
  margin: 5px 15px;
  border-bottom: 1px solid #f2f2f2;
  padding: 5px;
}
.read_leftt1_imgx {
  width: 200px;
  margin: 0 auto;
}
.image_box_row {
  width: 200px;
  margin: 200px auto 0 auto;
}
.fileName_box {
  margin-left: 10px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: 400;
  color: #666666;
  line-height: 26px;
}
._box {
  width: 100%;
  margin: 0 auto;
}
.top {
  margin-top: 30px;
}
</style>
